var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63316 3.79203C7.39456 3.79203 6.39062 4.7554 6.39062 5.9441C6.39062 7.13278 7.39456 8.09617 8.63316 8.09617C9.87089 8.09617 10.8749 7.13288 10.8749 5.9441C10.8749 4.75531 9.87089 3.79203 8.63316 3.79203ZM5.39062 5.9441C5.39062 4.22484 6.84266 2.83203 8.63316 2.83203C10.423 2.83203 11.8749 4.22493 11.8749 5.9441C11.8749 7.66328 10.423 9.05617 8.63316 9.05617C6.84266 9.05617 5.39062 7.66334 5.39062 5.9441Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90172 13.0843C5.99563 13.629 7.26774 13.8528 8.65307 13.8495H8.65554C10.0409 13.8528 11.3129 13.629 12.4069 13.0844C11.7719 11.662 10.3753 10.9753 8.6556 10.9796H8.653C6.93109 10.9753 5.53682 11.6604 4.90172 13.0843ZM8.65434 10.0196C6.47237 10.0146 4.52246 10.9899 3.8086 13.157L3.69043 13.5157L4.02508 13.7115C5.39962 14.5159 6.99618 14.8133 8.65434 14.8095C10.3125 14.8133 11.909 14.5159 13.2835 13.7115L13.6182 13.5157L13.5 13.157C12.7869 10.992 10.8341 10.0146 8.65434 10.0196Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06451 9.47658C3.488 9.47267 2.04797 10.1839 1.52343 11.7764L1.40527 12.1351L1.73991 12.331C2.27808 12.6459 2.86231 12.8526 3.47205 12.9753L3.96141 13.0738L4.16661 12.1342L3.67725 12.0358C3.30643 11.9611 2.95611 11.8516 2.62898 11.7024C3.06953 10.8517 3.95379 10.4338 5.06195 10.4366L5.56195 10.4378L5.56451 9.47779L5.06451 9.47658Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46977 4.79666L6.00809 4.61238C4.77324 4.11948 3.35526 4.68064 2.84153 5.86677C2.32781 7.0529 2.91334 8.41377 4.14819 8.90664C5.16809 9.31374 6.31128 9.00225 6.96858 8.21499L7.28129 7.8404L6.50099 7.24001L6.18828 7.61454C5.80214 8.07707 5.13019 8.25896 4.53212 8.02024C3.80705 7.73083 3.46328 6.93173 3.7649 6.23533C4.06651 5.53894 4.8991 5.20939 5.62417 5.49881L6.08585 5.68309L6.46977 4.79666Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.269 9.47658C13.8456 9.47267 15.2856 10.1839 15.8101 11.7764L15.9283 12.1351L15.5936 12.331C15.0555 12.6459 14.4712 12.8526 13.8615 12.9753L13.3722 13.0738L13.167 12.1342L13.6563 12.0358C14.0271 11.9611 14.3774 11.8516 14.7046 11.7024C14.264 10.8517 13.3798 10.4338 12.2716 10.4366L11.7716 10.4378L11.769 9.47779L12.269 9.47658Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6836 4.92972L11.1257 4.70551C12.1454 4.18839 13.435 4.43081 14.1678 5.33574C14.989 6.34994 14.7978 7.81087 13.7419 8.59877C12.6856 9.38693 11.1638 9.20453 10.3424 8.19026L10.0356 7.81131L10.8251 7.22213L11.132 7.60114C11.6141 8.19653 12.5077 8.30386 13.1282 7.84082C13.7482 7.37816 13.8604 6.52036 13.3782 5.92491C12.9485 5.39424 12.1911 5.25094 11.5928 5.55435L11.1507 5.77856L10.6836 4.92972Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadCount);
export default __webpack_public_path__ + "static/media/headCount.1e1f91509c6ded3560676018ae3bf4e2.svg";
export { ForwardRef as ReactComponent };